export default [
    {
        path: '/teacher-time-bank',
        name: 'teacher-time-bank',
        component: () => import('./pages/Index'),
        meta: {
            title: 'Banco de Horas Docente',
            icon: 'mdi-clock-outline',
            breadcrumbs: [
                { text: 'Banco de Horas Docente', disabled: true }
            ]
        }
    }
]
